import { isProfileFieldPermitted } from "PFCore/helpers/profile_permissions";
import { AccessLevel, PermissionsGroup, Profile } from "PFTypes";

import { PositionsList } from "./list/positions_list";

type PositionsSectionProps = {
  profile: Profile;
  permissionsGroup: PermissionsGroup;
  adminPage: boolean;
  handleProfileUpdate: VoidFunction;
  handleRemove: VoidFunction;
};

export const PositionsSection = ({
  permissionsGroup,
  adminPage,
  profile,
  handleProfileUpdate
}: PositionsSectionProps) => {
  const positions = profile?.positions || [];

  const canAddPosition = () =>
    isProfileFieldPermitted(
      permissionsGroup,
      profile?.permissionsGroup?.id,
      "otherPositions/dates",
      AccessLevel.ReadWrite
    );

  return (
    <PositionsList
      createDisabled={!canAddPosition()}
      handleAdd={handleProfileUpdate}
      handleUpdate={handleProfileUpdate}
      handleRemove={handleProfileUpdate}
      positions={positions}
      profile={profile}
      permissionsGroup={permissionsGroup}
      adminPage={adminPage}
    />
  );
};
